import { useEnhancedClickOutside } from '../../hooks/useEnhancedClickOutside'
import React from 'react'
import { useScrollPosition } from '../../hooks/useScrollPosition'
import CertificationsForm from './CertificationsForm'
import { type Certification, type CreateCertificationRequest } from '../../services/certificationService'

interface CertificationsModalProps {
  isOpen: boolean
  onClose: () => void
  onSuccess: (data: CreateCertificationRequest) => void
  isLoading?: boolean
  initialData?: Certification
  mode?: 'create' | 'edit'
}

const CertificationsModal: React.FC<CertificationsModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  isLoading = false,
  initialData,
  mode = 'create'
}) => {
  // Use the scroll lock hook
  useScrollPosition(isOpen)
  
  // Use enhanced click outside functionality
  const { handleBackdropMouseDown, handleBackdropMouseUp } = useEnhancedClickOutside(onClose)

  if (!isOpen) return null

  return (
    <div 
      className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center p-4 z-50"
      onMouseDown={handleBackdropMouseDown}
      onMouseUp={handleBackdropMouseUp}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-gray-900">
              {mode === 'edit' ? 'Edit Certification' : 'Add New Certification'}
            </h2>
            <button
              onClick={onClose}
              disabled={isLoading}
              className="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 disabled:opacity-50"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <CertificationsForm
            onSuccess={onSuccess}
            onCancel={onClose}
            initialData={initialData}
            mode={mode}
          />
        </div>
      </div>
    </div>
  )
}

export default CertificationsModal
